import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../Environment/environment';
@Component({
  selector: 'app-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrl: './image-dialog.component.css'
})
export class ImageDialogComponent {
  constructor(public dialogRef: MatDialogRef<ImageDialogComponent>,public dialog: MatDialog) {
    this.AssetbasePath = environment.assetsPath;
  }
  AssetbasePath:any;
  selectImage(imageName: string) {
    this.dialogRef.close(imageName); // Close the dialog and pass the selected image name
  }
  closePopup(){
    this.dialog.closeAll()
    }
}
